class MobileProductGallery extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.onHover = this.onHover.bind(this)
    this.onExitHover = this.onExitHover.bind(this)
    this.onPrevClick = this.onPrevClick.bind(this)
    this.onNextClick = this.onNextClick.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)
    this.onWindowScroll = this.onWindowScroll.bind(this)
    this.onScrollEnd = this.onScrollEnd.bind(this)
    this.onSlideIntersect = this.onSlideIntersect.bind(this)

    this.activeIndex = 0
    this.hasScrolled = false
    this.isScrolling = false

    this.mouseX = 0
    this.mouseY = 0
    this.scrollTimeout = null
    this.slideObserver = null
  }

  connectedCallback () {
    super.connectedCallback()

    this.indicators = this.els.indicator
  }

  disconnectedCallback () {
    this.slideObserver?.disconnect()

    super.disconnectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.slides = this.els.slide

    if (!this.slides.exists) return

    this.setupIntersectionObserver()

    this.listeners.add(this, 'mouseenter', this.onHover)
    this.listeners.add(this, 'mouseleave', this.onExitHover)

    if (this.els.prev?.exists) {
      this.listeners.add(this.els.prev.element, 'click', this.onPrevClick)
    }

    if (this.els.next?.exists) {
      this.listeners.add(this.els.next.element, 'click', this.onNextClick)
    }

    this.listeners.add(document, 'mousemove', this.onMouseMove)
    this.listeners.add(window, 'scroll', this.onWindowScroll)
  }

  setupIntersectionObserver () {
    this.slideObserver = new IntersectionObserver(this.onSlideIntersect, {
      threshold: 0.5,
    })

    this.slides.elements.forEach((slide, index) => {
      slide.dataset.index = index
      this.slideObserver.observe(slide)
    })
  }

  onSlideIntersect (entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return

      this.updateIndex(Number(entry.target.dataset.index))
    })
  }

  onMouseMove (event) {
    this.mouseX = event.clientX
    this.mouseY = event.clientY
  }

  onWindowScroll () {
    this.isScrolling = true

    clearTimeout(this.scrollTimeout)

    this.scrollTimeout = setTimeout(this.onScrollEnd, 150)
  }

  onScrollEnd () {
    this.isScrolling = false

    if (!this.canAutoAdvance) return

    const element = document.elementFromPoint(this.mouseX, this.mouseY)

    if (element?.closest('mobile-product-gallery') !== this) return

    this.showSecondImage()
  }

  onHover () {
    if (this.isScrolling) return
    if (!this.canAutoAdvance) return

    this.showSecondImage()
  }

  onExitHover () {
    if (this.mobileViewport) return

    this.hasScrolled = false
    this.activeIndex = 0

    this.scrollToIndex(0, 'instant')
  }

  onPrevClick (event) {
    event.preventDefault()
    event.stopPropagation()

    this.hasScrolled = true

    this.scrollToIndex(this.activeIndex - 1)
  }

  onNextClick (event) {
    event.preventDefault()
    event.stopPropagation()

    this.hasScrolled = true

    this.scrollToIndex(this.activeIndex + 1)
  }

  showSecondImage () {
    this.scrollToIndex(1, 'instant')
  }

  updateIndex (activeIndex) {
    this.activeIndex = activeIndex

    if (!this.indicators.exists) return

    this.indicators.elements.forEach((indicator) => {
      indicator.removeAttribute('aria-current')

      if (Number(indicator.dataset.index) <= activeIndex) {
        indicator.setAttribute('aria-current', true)
      }
    })
  }

  scrollToIndex (index, behavior = 'smooth') {
    if (!this.slides?.exists) return

    const total = this.slides.elements.length
    const wrapped = ((index % total) + total) % total
    const target = this.slides.elements[wrapped]

    if (!target) return

    this.activeIndex = wrapped

    const track = this.els.track?.exists
      ? this.els.track.element
      : target.parentElement

    track.scrollTo({
      left: target.offsetLeft,
      behavior,
    })
  }

  get canAutoAdvance () {
    return !this.mobileViewport && this.activeIndex === 0
  }

  get mobileViewport () {
    return window.matchMedia('(max-width: 1023px)').matches
  }
}

if (!customElements.get('mobile-product-gallery')) {
  customElements.define('mobile-product-gallery', MobileProductGallery)
}
